import landingRedirects from './landing-redirects.json';

const esc = (literal: string) => literal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Escape all RegExp metacharacters in a literal string.
 */
const pattern = new RegExp(
  Object.keys(landingRedirects)
    .sort((a, b) => b.length - a.length) // longest first
    .map(esc) // escape meta-chars
    .join('|'), // alternation
  'g' // global search
);

export const replaceLandingRedirects = (txt: string): string => {
  const chunks = txt.split(/(<iframe\b[\s\S]*?<\/iframe>)/gi);

  // avoiding touching iframes
  for (let i = 0; i < chunks.length; i += 2) {
    chunks[i] = chunks[i].replace(pattern, (matched) => {
      return (landingRedirects as { [key: string]: string })[matched];
    });
  }

  // extra replacement for short links
  // done separatly to not mess up longer links that can overlap with large link
  return chunks.join('')?.replaceAll('de-DE/leasing">', 'de-DE/auto/leasing">');
};
